import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { HotToastRef } from '@ngxpert/hot-toast';

@Component({
  selector: 'app-custom-notification',
  templateUrl: './custom-notification.component.html',
  styleUrls: ['./custom-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomNotificationComponent {
  public message: string;

  constructor(@Inject(HotToastRef) private readonly toastRef: HotToastRef<any>) {
    this.message = this.toastRef.data?.message || '';
  }

  close(): void {
    this.toastRef.close();
  }
}
